"use client";
import { useState } from "react";

export default function NewsletterOptin() {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            setStatus("Please enter a valid email address.");
            return;
        }
        // For demo, we'll just show success after 1 second.
        setStatus("Subscribing...");
        setTimeout(() => {
            setStatus("You’re subscribed! 🎉");
            setEmail("");
        }, 1000);
    };

    return (
        <section className="py-12 bg-primary/5 dark:bg-zinc-900">
            <div className="max-w-lg mx-auto px-4 text-center">
                <h2 className="text-2xl font-heading font-bold mb-2">
                    📧 Get our best stories in your inbox
                </h2>
                <p className="text-muted-foreground mb-4">
                    Join our free newsletter. No spam. Unsubscribe anytime.
                </p>
                <form
                    onSubmit={handleSubmit}
                    className="flex flex-col sm:flex-row gap-3 items-center justify-center"
                >
                    <input
                        type="email"
                        className="w-full sm:w-auto px-4 py-2 rounded border text-sm bg-white dark:bg-zinc-800 dark:text-white"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setStatus("");
                        }}
                        required
                    />
                    <button
                        type="submit"
                        className="bg-primary text-white px-6 py-2 rounded hover:bg-blue-700 font-medium"
                    >
                        Subscribe
                    </button>
                </form>
                {status && (
                    <p
                        className={`mt-3 text-sm ${
                            status === "You’re subscribed! 🎉"
                                ? "text-green-600 dark:text-green-400"
                                : "text-red-500"
                        }`}
                    >
                        {status}
                    </p>
                )}
            </div>
        </section>
    );
}
